export default "__VITE_ASSET__DYBErK7j__"